import classNames from 'classnames';
import React, { useMemo } from 'react';

import { Button } from '@/design-system/atoms/Button';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Text } from '@/design-system/atoms/Text';

import styles from './PRContact.module.scss';

const PRContact = ({ publisherName, publisherPhone, publisherEmail, ...props }) => {
    const hasTwoItems = useMemo(() => {
        return [publisherName, publisherPhone, publisherEmail].filter((item) => item).length === 2;
    }, [publisherName, publisherPhone, publisherEmail]);

    return (
        <ContentContainer>
            {(publisherName || publisherPhone || publisherEmail) && (
                <section
                    className={classNames(
                        styles[`pr-contact`],
                        hasTwoItems && styles[`pr-contact__two-items`],
                    )}
                    {...props}
                >
                    {publisherName && (
                        <Text
                            className={styles[`pr-contact__publisher-name`]}
                            variant={Text.VARIANT.T2}
                            tag={Text.TAG.P}
                            content={`PR contact: ${publisherName}`}
                        />
                    )}
                    {publisherPhone && (
                        <Button
                            className={styles[`pr-contact__publisher-name`]}
                            buttonStyle={Button.STYLE.TEXT}
                            label={publisherPhone}
                            href={`tel:${publisherPhone}`}
                            aria-label={`call ${publisherPhone}`}
                        />
                    )}
                    {publisherEmail && (
                        <Button
                            className={styles[`pr-contact__publisher-email`]}
                            href={`mailto:${publisherEmail}`}
                            label="Email"
                            aria-label={`send email to ${publisherEmail}`}
                            buttonStyle={Button.STYLE.TEXT}
                        />
                    )}
                </section>
            )}
        </ContentContainer>
    );
};

PRContact.propTypes = {};

export default PRContact;
